import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Document} from '../../models/document.model';
import {Headers, Http, RequestOptions, ResponseContentType} from '@angular/http';
import {Router} from '@angular/router';
import {UserService} from '../../services/user.service';
import {environment} from '../../../environments/environment';
import * as FileSaver from 'file-saver';
import {SessionTimeoutDialogComponent} from '../session-timeout-dialog/session-timeout-dialog.component';
import {MatDialog} from '@angular/material';

const rootURL: string = environment.serviceUrl;

@Component({
  selector: 'app-download-zip',
  templateUrl: './download-zip-package.component.html',
  styleUrls: ['./download-zip-package.component.css']
})
export class DownloadZipPackageComponent {

  @Input() docs: Document[];
  @Input() disable: boolean;
  @Output() downloadComplete: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private http: Http, private userService: UserService, public dialog: MatDialog, private router: Router) { }

  public downloadFile() {
    this.downloadComplete.emit(false);
    let docIds: number[] = [];
    for (const d of this.docs) {
      if (d.ViewFlag) {
        docIds.push(d.DocumentId);
        d.ViewFlag = false;
      }
    }
    const user = this.userService.getUser();
    const _headers = new Headers({
      'Content-Type': 'application/json',
      'ClientType': 'nomisign',
      'Authorization': 'Basic ' + user.SessionToken
    });
    const url = rootURL + 'api/documents/download/';
    const body: number[] = docIds;
    const options = new RequestOptions({method: 'POST', headers: _headers, responseType: ResponseContentType.Blob});
    return this.http.post(url, body, options)
        .subscribe(
            (res: any) => {
              let blob = res.blob();
              let filename = 'nominas.zip';
              FileSaver.saveAs(blob, filename);
              this.downloadComplete.emit(true);
            }, error => {
              if (error.status === 405) {
                this.dialog.closeAll();
                let dialogRef = this.dialog.open(SessionTimeoutDialogComponent, {
                  width: '75%'
                });
              } else {
                this.userService.clearUser();
                this.router.navigate(['/login']);
              }
              this.downloadComplete.emit(true);
            }
        );
  }

}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/download-zip-package/download-zip-package.component.ts